import RSAA from "redux-api-middleware/es/RSAA";
import {actions, defaultHeaders, types} from "../crud-actions";

export const NOTIFICATIONS_ADD = 'NOTIFICATIONS_ADD';
export const NOTIFICATIONS_SET = 'NOTIFICATIONS_SET';
export const NOTIFICATIONS_REMOVE = 'NOTIFICATIONS_REMOVE';
export const NOTIFICATIONS_CLEAR = 'NOTIFICATIONS_CLEAR';
export const NOTIFICATIONS_SYNC = 'NOTIFICATIONS_SYNC';
export const NOTIFICATIONS_SYNC_SUCCESS = 'NOTIFICATIONS_SYNC_SUCCESS';
export const NOTIFICATIONS_SYNC_ERROR = 'NOTIFICATIONS_SYNC_ERROR';
export const NOTIFICATIONS_DISMISS = 'NOTIFICATIONS_DISMISS';
export const NOTIFICATIONS_DISMISS_SUCCESS = 'NOTIFICATIONS_DISMISS_SUCCESS';
export const NOTIFICATIONS_DISMISS_ERROR = 'NOTIFICATIONS_DISMISS_ERROR';

export const addNotification = (type, text) => {
    return { type: NOTIFICATIONS_ADD, notification: { type: type, text: text  } };
};

export const setNotification = (type, text) => {
    window.scrollTo(0, 0);
    return { type: NOTIFICATIONS_SET, notification: { type: type, text: text  } };
};

export const removeNotification = (id) => {
    return { type: NOTIFICATIONS_REMOVE, id: id };
};

export const clearNotifications = () => {
    return { type: NOTIFICATIONS_CLEAR };
};

export const syncNotifications = () => {
    const filter = {};
    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/api/v1/notifications`,
            method: 'POST',
            headers: defaultHeaders,
            types: [
                { type: NOTIFICATIONS_SYNC, meta: { filter: filter }},
                { type: NOTIFICATIONS_SYNC_SUCCESS, meta: { filter: filter }},
                { type: NOTIFICATIONS_SYNC_ERROR, meta: { filter: filter }}
            ],
            credentials: 'same-origin',
            body: JSON.stringify(filter)
        },
        auth: true
    };
};

export const dismissNotification = (id) => {
    const filter = {};
    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/api/v1/notifications/${id}/dismiss`,
            method: 'POST',
            headers: defaultHeaders,
            types: [
                { type: NOTIFICATIONS_DISMISS, meta: { filter: filter }},
                { type: NOTIFICATIONS_DISMISS_SUCCESS, meta: { filter: filter }},
                { type: NOTIFICATIONS_DISMISS_ERROR, meta: { filter: filter }}
            ],
            credentials: 'same-origin',
            body: JSON.stringify(filter)
        },
        auth: true
    };
};
